/* @flow */

import React, { Component } from 'react';
import { Grid, Form, Header, Divider } from 'semantic-ui-react';
import ResourceCard from './ResourceCard';
import { VERTICAL_ALIGNS, HORIZONTAL_ALIGNS } from 'shared/constants/resources';

type Props = {
  resource?: BucketResource,
  horizontalAlign: HorizontalAlign,
  verticalAlign: VerticalAlign,
  parallaxEnabled: boolean,
  onSelected: (resource: BucketResource) => void,
  onChanged: (
    horizontalAlign: HorizontalAlign,
    verticalAlign: VerticalAlign,
    parallaxEnabled: boolean
  ) => void,
  onDeleted: () => void,
};

class ClientDrivenResourceCard extends Component {
  props: Props;

  onHorizontalAlignChanged = (_, { value: horizontalAlign }) =>
    this.props.onChanged(
      horizontalAlign,
      this.props.verticalAlign,
      this.props.parallaxEnabled
    );

  onVerticalAlignChanged = (_, { value: verticalAlign }) =>
    this.props.onChanged(
      this.props.horizontalAlign,
      verticalAlign,
      this.props.parallaxEnabled
    );

  onParallaxChanged = (_, { checked: parallaxEnabled }) =>
    this.props.onChanged(
      this.props.horizontalAlign,
      this.props.verticalAlign,
      parallaxEnabled
    );

  render() {
    const {
      resource,
      horizontalAlign,
      verticalAlign,
      parallaxEnabled,
      onSelected,
      onDeleted,
    } = this.props;

    const fieldDisabled = !resource;

    return (
      <Grid>
        <Grid.Row columns={2} divided>
          <Grid.Column>
            <Header as="h3" textAlign="center">Image Cible</Header>
            <ResourceCard
              resourceType="image"
              resource={resource}
              onSelected={onSelected}
              onDeleted={onDeleted}
            />
          </Grid.Column>
          <Grid.Column>
            <Header as="h3" textAlign="center">Configuration</Header>
            <Divider hidden />
            <Form>
              <Form.Select
                disabled={fieldDisabled}
                value={horizontalAlign}
                onChange={this.onHorizontalAlignChanged}
                label="Alignement horizontal"
                name="horizontalAlign"
                options={HORIZONTAL_ALIGNS}
              />
              <Form.Select
                disabled={fieldDisabled}
                value={verticalAlign}
                onChange={this.onVerticalAlignChanged}
                label="Alignement vertical"
                name="verticalAlign"
                options={VERTICAL_ALIGNS}
              />
              <Form.Checkbox
                disabled={fieldDisabled}
                checked={parallaxEnabled}
                onChange={this.onParallaxChanged}
                name="parallax"
                label="Parallax activée"
              />
            </Form>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default ClientDrivenResourceCard;



// WEBPACK FOOTER //
// ./src/shared/components/ClientDrivenResourceCard.js